"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEntries = void 0;
const axios_1 = __importDefault(require("axios"));
const getEntries = (space, baseUrl, contentType, query, additionalHeaders) => __awaiter(void 0, void 0, void 0, function* () {
    const url = `${baseUrl}/contentful/${space}/${String(contentType)}`;
    const cfg = {
        url,
        method: "post",
        headers: Object.assign({ "Content-Type": "application/json" }, (additionalHeaders || {})),
    };
    if (query) {
        cfg.data = {};
        if (query.queries)
            cfg.data.queries = query.queries;
        if (query.order)
            cfg.data.order = query.order;
        if (query.include)
            cfg.data.include = query.include;
        if (query.limit)
            cfg.data.limit = query.limit;
    }
    const resp = yield (0, axios_1.default)(cfg);
    return {
        status: (resp === null || resp === void 0 ? void 0 : resp.status) || 500,
        data: (resp === null || resp === void 0 ? void 0 : resp.data) || {},
    };
});
exports.getEntries = getEntries;
